import { SxProps } from '@mui/material';
import { Theme } from '@mui/system';

export const getTopographyStyle = (isSidebarOpen: boolean): SxProps<Theme> => {
  return isSidebarOpen ? { marginTop: '15px', textAlign: 'center' } : { margin: '15px 0 5px 20px' };
};
